// extracted by mini-css-extract-plugin
export default {"card":"PrintReportCards_card__9zRVb","title":"PrintReportCards_title__+C36e"};